import React, { useState, useEffect } from 'react';
import { products } from '../../data/products';
import HeroSection from './HeroSection';
import TrustBar from './TrustBar';
import ProductCard from '../../components/ui/ProductCard';
import SupplyChain from './SupplyChain';
import UbeEducation from './UbeEducation';
import RecipeCard from '../../components/recipes/RecipeCard';
import Button from '../../components/ui/Button';

const Home = () => {
  const featuredProducts = products.slice(0, 4);
  const [teaserRecipes, setTeaserRecipes] = useState([]);

  useEffect(() => {
    fetch('https://media-manager-c.questera.ai/greta-media/2f6847c5255962cb7ef6c818c843620d0179d6b0e810fa4ca1144f00d96707af10e5b2228b1b15861dc89ecefec6c49b/documents/YXBwbGljYXRpb24vanNvbg==/c511ac5c7aacfcfc68e1ca02573fc165.json')
      .then((response) => response.json())
      .then((data) => {
        const recipes = Array.isArray(data) ? data : (data.recipes || []);
        setTeaserRecipes(recipes.slice(0, 3));
      })
      .catch(console.error);
  }, []);

  return (
    <div className="flex flex-col">
      <HeroSection />
      <TrustBar />
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-end mb-12">
            <div>
              <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-2">Shop Essentials</h2>
              <p className="text-gray-600">Pure 100% Philippine ube powder.</p>
            </div>
            <Button to="/shop" variant="ghost" className="hidden sm:flex">View All Products &rarr;</Button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {featuredProducts.map((product) => <ProductCard key={product.id} product={product} />)}
          </div>
        </div>
      </section>
      <SupplyChain />
      <UbeEducation />
      {teaserRecipes.length > 0 && (
        <section className="py-24 bg-sand-light">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="font-serif text-3xl md:text-5xl text-gray-900 mb-4 text-balance">Real Ube Recipes</h2>
              <p className="text-gray-600 max-w-2xl mx-auto">From coastal lattes to heirloom bakes. Discover the versatility of Philippine ube.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {teaserRecipes.map((recipe) => <RecipeCard key={recipe.id} recipe={recipe} />)}
            </div>
            <div className="mt-16 text-center">
              <Button to="/recipes" variant="primary" size="lg">Explore Recipe Library</Button>
            </div>
          </div>
        </section>
      )}
      <section className="py-16 bg-lavender-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <h2 className="font-serif text-2xl md:text-3xl text-ube-dark mb-2 text-balance">Are you a cafe or bakery?</h2>
            <p className="text-gray-700">Get access to 20 kg (44 lbs) bulk bags, trade pricing, and dedicated support.</p>
          </div>
          <Button to="/wholesale" variant="primary" className="whitespace-nowrap">Apply for Wholesale</Button>
        </div>
      </section>
    </div>
  );
};

export default Home;